<script setup></script>

<template>
  <ul
    class="divide-y divide-gray-100 rounded-md border border-gray-200 bg-white"
  >
    <slot />
  </ul>
</template>
